import { useMediaQuery } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { find, includes, isEqual } from 'lodash'
import * as React from 'react'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ModelSpecialization } from '../../../../swagger/dto'
import { theme } from '../../../../theme'
import { ModelSpecializationIcon } from './ModelSpecializationIcon'

const allSpecialization = [
    ModelSpecialization.Universal,
    ModelSpecialization.Art,
    ModelSpecialization.Coding,
    ModelSpecialization.Research,
    ModelSpecialization.Analysis,
]

const specializationListMap = [
    {
        key: ModelSpecialization.Universal,
        label: 'Универсальная модель',
    },
    {
        key: ModelSpecialization.Art,
        label: 'Творчество',
    },
    {
        key: ModelSpecialization.Coding,
        label: 'Код и разработка',
    },
    {
        key: ModelSpecialization.Research,
        label: 'Исследование и размышление',
    },
    {
        key: ModelSpecialization.Analysis,
        label: 'Анализ',
    },
]

export const SpecializationSelect = ({ isProtectedCurrentProject }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [searchParams, setSearchParams] = useSearchParams()
    const [specializationList, setSpecializationList] = React.useState<string[]>(allSpecialization)

    const handleChange = (event: SelectChangeEvent<typeof specializationList>) => {
        const {
            target: { value },
        } = event
        if (includes(value, 'all') || isEqual(value, [])) {
            setSpecializationList(allSpecialization)
        } else {
            setSpecializationList(typeof value === 'string' ? value.split(',') : value)
        }
    }

    useEffect(() => {
        searchParams.set('specialization', specializationList)
        setSearchParams(searchParams)
    }, [specializationList])

    return (
        <FormControl
            sx={{
                display: isProtectedCurrentProject ? 'none' : 'display',
                width: isMobile ? '100%' : '240px',
                height: '40px',
                mb: isMobile ? 2 : 0,
            }}>
            <Select
                color="secondary"
                sx={{
                    '& .MuiSelect-select': {
                        padding: '10px 16px !important',
                        '& .MuiTypography-h6': { width: '210px' },
                    },
                }}
                labelId="specialization-multiple-checkbox-label"
                id="specialization-multiple-checkbox"
                multiple
                value={specializationList}
                onChange={handleChange}
                renderValue={(selected) => (
                    <Stack
                        sx={{
                            width: isMobile ? '320px' : '196px',
                        }}>
                        {isEqual(selected, allSpecialization) || selected.length > 1 ? (
                            <>
                                <Typography variant="body2">
                                    {isEqual(selected, allSpecialization)
                                        ? 'Все специализации'
                                        : `Выбрано ${selected.length} специализации`}
                                </Typography>
                            </>
                        ) : (
                            <Typography
                                variant="body2"
                                sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}>
                                {
                                    find(specializationListMap, {
                                        key: selected[0],
                                    })?.label
                                }
                            </Typography>
                        )}
                    </Stack>
                )}>
                <MenuItem
                    key="all"
                    value="all"
                    sx={{
                        justifyContent: 'space-between',
                        '&.Mui-selected': { background: 'none' },
                        borderBottom: '1px solid #F4F4F6',
                    }}>
                    <Stack direction="row" spacing={1}>
                        <Typography variant="caption1"> Все специализации</Typography>
                    </Stack>
                    <Checkbox checked={isEqual(specializationList, allSpecialization)} />
                </MenuItem>

                {specializationListMap.map(({ key, label }) => (
                    <MenuItem
                        key={key}
                        value={key}
                        sx={{
                            justifyContent: 'space-between',
                            '&.Mui-selected': { background: 'none' },
                        }}>
                        <Stack direction="row" spacing={1}>
                            <ModelSpecializationIcon specialization={key} />
                            <Typography variant="caption1">{label}</Typography>
                        </Stack>

                        <Checkbox checked={specializationList.includes(key)} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
